﻿import { deleteCookie, getCookie } from "../../storage";
import { getRegisterValues } from "./register";
import { showModal, closeModal, EuiModalSize } from "../../components/modal";

$(() => {
  $("#removeRegisterValuesBtn").on("click", () => {
    deleteCookie(REGISTER_COOKIE_NAME, "/");
    closeModal();
  });

  const params = new URLSearchParams(window.location.search);
  const registerValues = getRegisterValues();

  if (registerValues.country !== CURRENT_COUNTRY_CODE) {
    deleteCookie(REGISTER_COOKIE_NAME, "/");
  }

  if (!params.get("fill") && getCookie(REGISTER_COOKIE_NAME)) {
    showModal("#resumeRegisterModal", {
      overlayClose: false,
      size: EuiModalSize.S,
    });
  }
});
